import type { RegisterRequest, RegisterResponse } from './Type'
import { request } from '@/utils/Request'

/**
 * 注册用户
 * @param data 注册请求数据
 * @returns 注册成功后的响应数据
 */
export async function register(data: RegisterRequest) {
  return request.post<RegisterResponse>("/api/user/reg", data);
}